import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { CommentFull } from '../../index';
import utils from '../../../utils';

const renderComments = (props) => {
  const {
    comments,
    userID,
    isDeletingSuccessDialog,
    setDeletingSuccessDialog,
  } = props;

  return comments
    ?.sort((a, b) => {
      if (a?.creationDateByMoscow < b?.creationDateByMoscow) {
        return 1;
      }
      if (a?.creationDateByMoscow > b?.creationDateByMoscow) {
        return -1;
      }
      return 0;
    })
    ?.map((item) => {
      return (
        <Box key={utils.addID()} mb={1}>
          <CommentFull
            key={utils.addID()}
            userID={userID}
            comment={item}
            isDeletingSuccessDialog={isDeletingSuccessDialog}
            setDeletingSuccessDialog={setDeletingSuccessDialog}
          />
        </Box>
      );
    });
};

const CommentsList = (props) => {
  const { comments } = props;
  const hasComments = () => {
    if (typeof comments === 'string') {
      return false;
    } else if (Array.isArray(comments)) {
      return true;
    }
  };

  return (
    <>
      {hasComments() && (
        <>
          <Typography variant="h5" gutterBottom>
            Комментарии руководителей
          </Typography>

          {renderComments(props)}
        </>
      )}
    </>
  );
};

export default CommentsList;
